import logo from "./logo.svg";
import "./App.css";
import React from "react";
import Navbar from "./componentes/NavBar/Navbar.jsx";
import Footer from './componentes/footer/Footer.jsx'
import SobreMi from "./componentes/SobreMi/SobreMi";
import Proyectos from "./componentes/Proyectos/Proyectos";
import Tecnologias from "./componentes/Tecnologias/Tecnologias";
import Cursos from "./componentes/Cursos/Cursos";
function App() {
  return (
    <div>
      <Navbar />
      <Cursos/>
      <Tecnologias/>
      <Proyectos/>
      <Footer/>
    </div>
  );
}

export default App;
